import { Redirect, Route, Switch } from "react-router-dom";
import Landing from "pages/Landing";
import Profile from "pages/Profile";
import Login from "pages/Login";
import Home from "pages/Home";
import Register from "pages/Register"; // Font Awesome Style Sheet
import "@fortawesome/fontawesome-free/css/all.min.css"; // Tailwind CSS Style Sheet
import "assets/styles/tailwind.css";
import SetLocation from "./pages/SetLocation";
import { useState } from "react";
import SqMap from "./pages/SqMap";
import AlertTemplate from "react-alert-template-basic";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  const [positionGlobal, setPositionGlobal] = useState({
    lat: 51.41,
    lng: 21.04,
  });
  const options = {
    // you can also just use 'bottom center'
    position: positions.TOP_CENTER,
    timeout: 5000,
    offset: "30px",
    // you can also just use 'scale'
    transition: transitions.SCALE,
  };
  const handleCallback = (childData) => {
    // console.log(childData)
    setPositionGlobal(childData);
  };
  const [shLink, setshLink] = useState("");
  const handleCallbackshLink = (childData) => {
    // console.log(childData)
    setshLink(childData);
  };
  return (
    <AlertProvider template={AlertTemplate} {...options}>
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => (
            <Home
              positionGlobal={positionGlobal}
              shLink={shLink}
              handleCallbackshLink={handleCallbackshLink}
            />
          )}
        />
        <Route
          exact
          path="/everytile"
          render={(props) => (
            <Landing
              positionGlobal={positionGlobal}
              shLink={shLink}
              handleCallbackshLink={handleCallbackshLink}
            />
          )}
        />
        <Route
          exact
          path="/setLocation"
          render={(props) => (
            <SetLocation
              positionGlobal={positionGlobal}
              handleCallback={handleCallback}
              shLink={shLink}
            />
          )}
        />
        <Route
          exact
          path="/tilesize"
          render={(props) => (
            <SetLocation
              positionGlobal={positionGlobal}
              handleCallback={handleCallback}
              shLink={shLink}
            />
          )}
        />
        <Route
            exact
            path="/privacyPolicy"
            render={(props) => (
                <PrivacyPolicy
                    positionGlobal={positionGlobal}
                    handleCallback={handleCallback}
                    shLink={shLink}
                />
            )}
        />
        <Route
          exact
          path="/squaremap"
          render={(props) => (
            <SqMap
              positionGlobal={positionGlobal}
              handleCallback={handleCallback}
              shLink={shLink}
            />
          )}
        />
        {/**/}
        <Route exact path="/profile" component={Profile} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/register" component={Register} />
        <Redirect from="*" to="/" />
      </Switch>
    </AlertProvider>
  );
}

export default App;
